export const EMPLOYEE_STATUS_BLOCKED = -1
export const EMPLOYEE_STATUS_INACTIVE = 0
export const EMPLOYEE_STATUS_ACTIVE = 1

export const EMPLOYEE_STATUS_LABELS = [
  {
    label: 'Заблокирован',
    value: EMPLOYEE_STATUS_BLOCKED
  },
  {
    label: 'Отключён',
    value: EMPLOYEE_STATUS_INACTIVE
  },
  {
    label: 'Активен',
    value: EMPLOYEE_STATUS_ACTIVE
  }
]


export const ASSEMBLER_ROLES = [
  { 
    label: 'Сборщик товаров', 
    value: 'picker',
    description: 'Сборщик, который собирает только товары. Не может завершить заказ без проверки проверяющим'
  },
  {
    label: 'Контроллер',
    value: 'packer',
    description: 'Проверяет собранные заказы. Может самостоятельно собирать заказы при их наличии'
  },
  {
    label: 'Сборщик заказов (товары + заказ)',
    value: 'assembler',
    description: 'Сборщик, который может самостоятельно закрыть весь цикл сборки: товары, оплата, выдача заказа'
  },
  {
    label: 'Старший смены',
    value: 'leader',
    description: 'Старший смены, может вносить изменения в заказы, проверять сборщиков и упаковывателей'
  }
]